import { theme } from '../theme';

export const formStyles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 'calc(100vh - 56px)',
    padding: '20px',
  },
  card: {
    width: '100%',
    maxWidth: '400px',
    background: theme.bgPanel,
    borderRadius: theme.radiusLg,
    border: `1px solid ${theme.border}`,
    padding: '32px',
  },
  title: {
    fontSize: '24px',
    fontWeight: 700,
    color: theme.textPrimary,
    marginBottom: '24px',
    textAlign: 'center' as const,
  },
  field: {
    marginBottom: '16px',
  },
  label: {
    display: 'block',
    fontSize: '13px',
    color: theme.textSecondary,
    marginBottom: '6px',
  },
  input: {
    width: '100%',
    padding: '10px 12px',
    borderRadius: theme.radiusMd,
    border: `1px solid ${theme.border}`,
    background: theme.bgInput,
    color: theme.textPrimary,
    fontSize: '14px',
    outline: 'none',
  },
  btn: {
    width: '100%',
    padding: '10px',
    borderRadius: theme.radiusMd,
    border: 'none',
    cursor: 'pointer',
    fontSize: '15px',
    fontWeight: 600,
    background: theme.accent,
    color: theme.accentText,
    marginTop: '8px',
  },
  error: {
    color: theme.error,
    fontSize: '13px',
    marginBottom: '12px',
    textAlign: 'center' as const,
  },
  success: {
    color: theme.success,
    fontSize: '13px',
    marginBottom: '12px',
    textAlign: 'center' as const,
  },
  text: {
    color: theme.textSecondary,
    fontSize: '14px',
    lineHeight: 1.5,
    textAlign: 'center' as const,
  },
  footer: {
    textAlign: 'center' as const,
    marginTop: '16px',
    fontSize: '13px',
    color: theme.textMuted,
  },
  link: {
    color: theme.accent,
    textDecoration: 'none',
  },
};
